import React from 'react';
import CompetitionModuleNewsBlock from 'app/components/competitionModule/news/CompetitionModuleNewsBlock';
import CompetitionModuleNewsList from 'app/components/competitionModule/news/CompetitionModuleNewsList';
import SectionHeading from 'app/components/competitionModule/common/SectionHeading';
export default function CompetitionModuleLatestNews(_ref) {
  let {
    news,
    moduleIndex
  } = _ref;
  return /*#__PURE__*/React.createElement(CompetitionModuleNewsBlock, {
    hide: !news.length,
    "data-sentry-element": "CompetitionModuleNewsBlock",
    "data-sentry-component": "CompetitionModuleLatestNews",
    "data-sentry-source-file": "CompetitionModuleLatestNews.tsx"
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    "data-sentry-element": "SectionHeading",
    "data-sentry-source-file": "CompetitionModuleLatestNews.tsx"
  }, "Aktuelle Meldungen"), /*#__PURE__*/React.createElement(CompetitionModuleNewsList, {
    moduleIndex: moduleIndex,
    data: news,
    "data-sentry-element": "CompetitionModuleNewsList",
    "data-sentry-source-file": "CompetitionModuleLatestNews.tsx"
  }));
}